import type { ReactNode } from "react";
import { Eyebrow } from "../ui/ds";

/** The white card with the accent rule and logo row used by every sign-in screen. */
export function GateCard({
  eyebrow,
  title,
  sub,
  steps,
  wide,
  children,
  foot,
}: {
  eyebrow: string;
  title: string;
  sub?: ReactNode;
  steps?: [number, number];
  wide?: boolean;
  children: ReactNode;
  foot?: ReactNode;
}) {
  return (
    <div className="gate">
      <div className={`gate-col${wide ? " is-wide" : ""}`}>
        <div className="gate-card">
          <div className="accent-rule" />
          <div className="brandrow" style={{ marginBottom: 32 }}>
            <img src="/agile-icon.png" alt="" />
            <span>Agile Vault</span>
          </div>
          {steps ? (
            <div className="steps" aria-label={`Step ${steps[0]} of ${steps[1]}`}>
              {Array.from({ length: steps[1] }, (_, i) => (
                <span key={i} className={i < steps[0] ? "is-on" : ""} />
              ))}
            </div>
          ) : null}
          <Eyebrow size="sm">{eyebrow}</Eyebrow>
          <h1 className="gate-title">{title}</h1>
          {sub ? <p className="gate-sub">{sub}</p> : null}
          {children}
        </div>
        {foot ? <div className="gate-foot">{foot}</div> : null}
      </div>
    </div>
  );
}
